import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {AttributePref} from '@netx/core-attribute/constants';
import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {
	currentUserHasAssetAttributeAccess,
	legacyPermissionsEnabled,
} from '@netx/core-permissions-next/enablers';

export const canQuickEdit = () => {
	if (legacyPermissionsEnabled())
		return (
			currentUserMeetsUserLevel(UserLevel.PRODUCER) ||
			getPreference(AttributePref.ALL_USERS_PERMITTED_TO_EDIT, true)
		);

	return currentUserHasAssetAttributeAccess();
};
